export default "__VITE_ASSET__DjcnW3ti__"